import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageListType } from 'react-images-uploading';
import styles from './branding-details.module.scss';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import ImageUploading from 'react-images-uploading';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import EditIcon from '@material-ui/icons/Edit';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import DeleteIcon from '@material-ui/icons/Delete';

export interface BrandingDetailsProps {
  data: {
    submitLoading?: boolean;
    unitTypeId: string;
    brandingImage?: {
      id: string;
      order: number;
      url: string;
    }[];
  };
  eventHandlers: {
    uploadBrandingImage: (file: File, brandingImageIndex: number) => void;
    deleteBrandingImage: (id: string) => void;
  };
}

const BrandingDetails: React.FC<BrandingDetailsProps> = ({ data, eventHandlers }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const [imagesList, setImagesList] = useState<
    {
      dataURL?: string;
      file?: File | undefined;
      order?: number;
      id?: string;
    }[]
  >([]);

  useEffect(() => {
    if (data?.brandingImage) {
      setImagesList(
        data.brandingImage.map((detail) => ({
          dataURL: detail.url || '',
          file: undefined,
          order: detail.order,
          id: detail.id
        }))
      );
    }
  }, [data.brandingImage]);

  const { t } = useTranslation();
  const isMobileView = useWindowResizer();

  const handleImageChange = (imageList: ImageListType, index: number) => {
    const newImageList = [...imagesList];
    newImageList[index] = {
      ...newImageList[index],
      ...imageList[0]
    };
    setImagesList(newImageList);
  };

  const handleSubmit = (index: number) => {
    const image = imagesList[index];
    console.log(image);
    if (image?.file) {
      eventHandlers.uploadBrandingImage(image.file, image.order || activeIndex + 1);
    }
  };

  const handleDeleteClick = (id: string | undefined): void => {
    if (!id) return;

    eventHandlers.deleteBrandingImage(id);
  };

  return (
    <div className={styles['branding-details-container']}>
      <div className={styles['branding-details-container__header']}>Branding images</div>
      <div className={styles['branding-details-container__tabs']}>
        {[0, 1].map((index) => (
          <button
            type="button"
            key={index}
            className={`${styles['branding-details-container__tab']} ${
              activeIndex === index ? styles.active : ''
            }`}
            onClick={() => setActiveIndex(index)}
          >
            Image {index + 1}
          </button>
        ))}
      </div>

      <div className={styles['branding-details-container__content']}>
        <div className={styles['branding-details-container__field']}>
          <ImageUploading
            value={imagesList[activeIndex] ? [imagesList[activeIndex]] : []}
            onChange={(imageList) => handleImageChange(imageList, activeIndex)}
            maxNumber={1}
            dataURLKey="dataURL"
          >
            {({ imageList, onImageUpload, onImageUpdate, isDragging, dragProps }) => (
              <div className={styles['upload-image-wrapper']}>
                {imageList.length > 0 ? (
                  <div className={styles['image-container']}>
                    <img src={imageList[0].dataURL} alt="Compound" />
                    <div
                      className={styles['image-controls']}
                      style={{
                        display: imagesList[activeIndex]?.id ? 'none' : 'flex'
                      }}
                    >
                      <button type="button" onClick={() => onImageUpdate(0)}>
                        <EditIcon fontSize="large" />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    className={styles.dropzone}
                    {...dragProps}
                    onClick={onImageUpload}
                    style={isDragging ? { border: '2px dashed #4a90e2' } : undefined}
                  >
                    <CloudUploadIcon fontSize="large" />
                    <span>{t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.UPLOAD_IMAGE')}</span>
                  </div>
                )}
              </div>
            )}
          </ImageUploading>
        </div>
        {imagesList[activeIndex]?.file && (
          <div className={styles['branding-details-container__actions']}>
            <Button
              onClick={() => handleSubmit(activeIndex)}
              tracking={{
                action: 'submit',
                category: 'compound-details',
                label: 'compound-details-update'
              }}
              disabled={!imagesList[activeIndex]?.file || data.submitLoading}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            >
              {data.submitLoading ? 'Uploading' : 'Upload'}
            </Button>
          </div>
        )}
        {imagesList[activeIndex]?.id && (
          <div className={styles['branding-details-container__actions']}>
            <Button
              type={ButtonType.danger}
              onClick={() => handleDeleteClick(imagesList[activeIndex]?.id)}
              tracking={{
                action: 'delete',
                category: 'branding-image-details',
                label: 'branding-image-details'
              }}
              disabled={data.submitLoading}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            >
              {data.submitLoading ? 'Deleting' : 'Delete'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandingDetails;
